import { render, staticRenderFns } from "./InventoryNotification.vue?vue&type=template&id=43ed06fc"
import script from "./InventoryNotification.vue?vue&type=script&lang=js"
export * from "./InventoryNotification.vue?vue&type=script&lang=js"
import style0 from "./InventoryNotification.vue?vue&type=style&index=0&id=43ed06fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports